export const LOCALSTORAGE_KEY_JWT = "JWT"
export const LOCALSTORAGE_KEY_USER = "AUTHUSER"
export const LOCALSTORAGE_KEY_AUTH = "AUTH"